<template>
  <div class="container-fluid">
    <section class="row">
      <div>
        <div class="mt-3 text-center">
          <img src="../../assets/join_car.png" class="w-50"/>
        </div>
        <p class="text-center fs-title fw-bold mb-0">환영합니다! 화면이동중입니다.:)</p>
      </div>
    </section>
    <footer class="footer d-flex flex-column mt-3 d-flex gap-1">
      <button class="btn btn-primary col-12 rounded-pill" @click="moveAttach">추가 정보 기입하기</button>
      <button class="btn btn-outline-primary col-12 rounded-pill" @click="moveAfter">다음에 하기</button>
    </footer>

  </div>
</template>

<script>

import Utils from "@/assets/js/CommonComposables";
import parsePhoneNumberFromString from "libphonenumber-js/max";
import {isSocialLogin} from "@/assets/js/SocialLoginComposables";
/**
 * 간편회원가입 - 가입 완료페이지
 */
export default {
  name: "JoinEvent20",
  data(){
    return {
      iv: this.$CryptoJS.enc.Hex.parse('0000000000000000'),
      key: this.$CryptoJS.enc.Utf8.parse('alkdjalsdjivlake'),
      currentPageData: {
        page : '',
      },
      userInfo : {
        birth : '850812',
        gender : '1',
        name : '홍길동',
        national : '1',
        mobile : '01012341234',
        user_seq: 0
      },
      memberCreateParam:{
        act_app             : 101,
        name                : "", // 이름
        mobile              : "", // 전화번호
        birthday            : "", // 생년월일 + 성별코드
        corp_ceo_personno1  : "", // 주민번호 앞자리
        corp_ceo_personno2  : "", // 주민번호 뒷자리
        corp_ceo_personno_tmp  : "", // 주민번호 암호화전 뒷자리

        address1            : "", // 주소
        address2            : "",	// 상세주소
        zipcode             : "", // 주소우편번호
        user_carnum         : "",	// 차량번호
        user_cartype        : "카고",	// 차종
        user_cartypecode    : 1,	// 차종코드
        user_carsize        : "25톤",	// 차 사이즈
        user_carsizecode    : 2500,	// 차 사이즈코드
        group_code          : null,// 개별협회 코드
        grade_code          : null,// 회원구분 (모바일,만차로구분)

        corp_num            : "", // 사업자번호
        email               : "",	// 사용자 이메일 (non-required)
        taxemail            : "", // 전자계산서 이메일 (non-required)

        rbank_type          : "",	// 계좌구분
        rbank_typecode      : "",	// 은행코드
        rbank_num           : "",	// 계좌번호
        rbank_username      : "",	// 예금주

        img_sign            : "",	// 서명정보
        img_usersign        : "", // 예금주서명

        //차주 예치금 운용 동의
        point_used_agree    : `N`,

        phone_check         : 1, //   본인인증 1:인증 0:미인증
        car_check           : 0, //   차량인증 1:인증 0:미인증
        corp_check          : 0, //   사업자인증 1:인증 0:미인증
        rbank_check         : 0, //   은행인증 1:인증 0:미인증
        rbank_typecode_num  : null,// 계좌구분 1:개인계좌, 2:법인계좌
      },
      selectedGender : 0,
      nationalName : '',
      isVerified:true,
      homeName:'',
      joinUrl:'',
      test_mode:false,
      code:'',
    }
  },
  async mounted() {
    this.joinUrl = this.$store.getters.getJoinUrl; // 다음 페이지 이동시 필요
    this.test_mode = this.$store.getters.getTestEnv; // 테스트 모드시 필요
    this.homeName = this.joinUrl === 'mancharo' ? '만차로' : '화물맨';

    if (this.$store.getters.getTestEnv) {
      // 테스트로 접속한 경우
    } else {
      this.userInfo.birth = '';
      this.userInfo.gender = '';
      this.userInfo.name = '';
      this.userInfo.national = '';
      this.userInfo.mobile = '';
    }

    try {
      const accessToken = this.$store.getters.getAccessToken;
      if (accessToken){
        // 1. 카카오 회원정보 요청 및 처리
        const kakaoResponse = await this.$http.post('/api/kakao/member/info', {
          access_token: accessToken
        });
        const response = kakaoResponse.data;
        if (response.error) {
          await this.handleKakaoError(response.message);
          return;
        }
        await this.processKakaoData(response.data);
      }

      // 2. 사용자 휴대전화 정보 확인
      if (!this.userInfo.mobile) {
        await this.alertAndRedirect('휴대전화 정보가 없습니다.');
        return;
      }

      // 3. 다음 페이지 진행 처리 (테스트 모드가 아닐 경우)
      await this.processNextStep();
    } catch (ex) {
      console.error("예외 발생:", ex);
    }
  },
  methods:{
    // 카카오 응답 에러 처리
    async handleKakaoError(message) {
      this.isVerified = false; // 창 숨기기
      await this.$swal.fire({ title: message });
      await this.$router.push({ path: '/' });
    },

    // 카카오 데이터 처리 (카카오 계정 존재 여부와 데이터 완전성 확인)
    async processKakaoData(data) {
      const { kakao_account: kakaoAccount, id: kakaoId } = data;

      // 카카오 계정이 존재하지 않는 경우
      if (!kakaoAccount) {
        this.kakaoUnlink();
        return;
      }

      // 필수 데이터가 모두 존재하는 경우
      if (Utils.isNotNullAll(
          kakaoAccount.name,
          kakaoAccount.birthyear,
          kakaoAccount.birthday,
          kakaoAccount.phone_number,
          kakaoAccount.gender
      )) {
        this.$store.commit('changeIsSocialLogin', true);
        this.userInfo.name = kakaoAccount.name;
        this.userInfo.gender = ''; // 성별은 별도 처리 (아래에서 선택)
        this.userInfo.birth = `${kakaoAccount.birthyear}${kakaoAccount.birthday}`;
        const phoneNumber = parsePhoneNumberFromString(kakaoAccount.phone_number);
        this.userInfo.mobile = this.removeHyphens(phoneNumber.formatNational());
        this.selectedGender = kakaoAccount.gender === 'male' ? '1' : '0';

        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('setSocialId', kakaoId);
      } else {
        // 필수 데이터가 누락된 경우: 카카오 연결 해제 후 본인인증 진행
        this.kakaoUnlink();
        this.showConfirm();
      }
    },

    // 사용자 정보 부족시 경고 후 메인으로 이동
    async alertAndRedirect(message) {
      await this.$swal.fire(message);
      await this.$router.push({ path: '/' });
    },

    // 다음 단계 진행 (회원가입/정보 입력 관련)
    async processNextStep() {
      const nextPageInfo = await this.$http.post('/api/user/reg/mmn/v2', this.userInfo)
          .catch(err => {
            this.$swal.fire('에러: ' + err.message);
          });
      if (!nextPageInfo) return;

      if (nextPageInfo.data.code !== 200) {
        await this.$swal.fire(nextPageInfo.data.message);
        await this.$router.push({ path: '/' });
        return;
      }

      await this.handlePageRouting(nextPageInfo.data.data, nextPageInfo.data.message);
    },
    async processAutoJoinMember() {
      const memberCreateParam = {
        act_app: 101,
        name: this.userInfo.name,
        mobile: this.userInfo.mobile,
        birthday: this.userInfo.birth.length === 8 ? this.userInfo.birth.substring(2, 8) : this.userInfo.birth,
        corp_ceo_personno1: this.userInfo.birth.length === 8 ? this.userInfo.birth.substring(2, 8) : this.userInfo.birth,
        corp_ceo_personno2: "",
        corp_ceo_personno_tmp: "",
        regbelong: "2",
        address1: "",
        address2: "",
        zipcode: "",
        user_carnum: "",
        user_cartype: "카고",
        user_cartypecode: 1,
        user_carsize: "25톤",
        user_carsizecode: 2500,
        group_code: null,
        grade_code: sessionStorage.getItem("grade-code"),
        corp_num: "",
        email: "",
        taxemail: "",
        rbank_type: "",
        rbank_typecode: "",
        rbank_num: "",
        rbank_username: "",
        img_sign: "",
        img_usersign: "",
        point_used_agree: `N`,
        phone_check: 1,
        car_check: 0,
        corp_check: 0,
        rbank_check: 0,
        rbank_typecode_num: null,
      };

      try {
        const response = await this.$http.post('/api/user/add/cw', memberCreateParam);
        if (response.data.error === false) {
          const user_seq = response.data.data.seq;
          this.$store.commit('setUserSeq', user_seq);
          this.$store.commit('setGradeCode', memberCreateParam.grade_code);
          if (isSocialLogin()) {
            const socialCorpName = this.$store.getters.getSocialCorpName;
            const socialId = this.$store.getters.getSocialId;
            await this.$http.post('/api/simplejoin/social/id', {
              user_seq,
              provider_corp_name: socialCorpName,
              social_login_id: socialId,
              mobile: memberCreateParam.mobile,
              type: 1 // 차주: 1, 화주: 2
            });
          }
        } else {
          await this.$swal.fire(response.data.message);
        }
      } catch (error) {
        await this.$swal.fire(error.response.data.message);
      }
    },
    // 페이지 라우팅 처리: 가입 경로에 따라 화면 분기
    async handlePageRouting(pageRouteInfo) {
      const router_view = pageRouteInfo.router_view;
      const user_seq = pageRouteInfo.user_seq;
      if (router_view === 'UNKNOWN_MEMBER') {
        console.log(`this.userInfo => `, this.userInfo);
        await this.processAutoJoinMember();
        this.currentPageData.page = 'member-final';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }
      this.$store.commit('setUserSeq', user_seq);
      // 신규 가입 또는 정보 미입력 경우
      if (router_view === 'INFO') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // 가입 완료되었으나 첨부 서류 미비한 경우
      if (router_view === 'PAPER') {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-paper';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      // PAPER와 INFO가 같이 포함된 경우
      if (router_view.includes("PAPER") && router_view.includes("INFO")) {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', router_view);
        this.$emit('current-page', this.currentPageData);
      }
    },
    moveAfter(){
      let isMancharo = this.$store.getters.getJoinUrl;
      let url = "https://www.2424-2424.com";
      if(isMancharo === 'mancharo') {
        url = "https://mancharo.com/";
      }
      // this.sendAttachLink()
      window.location.href = url;
    },
    async moveAttach(){
      //테스트 모드가 아닐 경우 실행
      const nextPageInfo = await this.$http.post('/api/user/reg/mmn/v2', this.userInfo)
          .catch(err=> {
            this.$swal.fire('에러 : '+err.message);
          });

      if (nextPageInfo === undefined) {
        return ;
      }

      // if(nextPageInfo.data.code !== 200){
      //   await this.$swal.fire(`회원님은 서비스 \n이용이력이 있으신 회원이십니다.\n콜센터를 통해서 \n가입신청을 진행하십시오.`);
      //   return;
      // }
      if(nextPageInfo.data.code !== 200){
        await this.$swal.fire(`${nextPageInfo.data.message}`);
        await this.$router.push({ path: '/' });
        return;
      }

      const pageRouteInfo = nextPageInfo.data.data.router_view;
      // 가입 경로부터 확인하기
      console.log(`sessionStorage.getItem("grade-code") => `, sessionStorage.getItem("grade-code"));
      console.log(`typeof sessionStorage.getItem("grade-code") => `,typeof sessionStorage.getItem("grade-code"));
      console.log(`compare sessionStorage.getItem("grade-code") => `,sessionStorage.getItem("grade-code") === '100208');
      /*
      라우터 위치 정하기
       8 - 화물맨
      11 - 만차로
      12 - 아틀란
      20 - 회원가입 간소화
       */
      if (pageRouteInfo === 'UNKNOWN_MEMBER') {
        console.log("신규가입 대상자입니다.")
        //화물맨 기본 로직
        const join_path = sessionStorage.getItem("grade-code");

        if (join_path === '8' || join_path === '11') {
          this.currentPageData.page = 'hmm';
        } else if (join_path === '12') {
          this.currentPageData.page = 'atl';
        } else if (join_path === '100208') {
          this.currentPageData.page = 'event20';
        }
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      if (pageRouteInfo === "INFO") {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      if (pageRouteInfo === "PAPER") {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-paper';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
        return;
      }

      if (pageRouteInfo.includes("PAPER") && pageRouteInfo.includes("INFO")) {
        console.log(`this.userInfo => `, this.userInfo);
        this.currentPageData.page = 'member-info';
        this.$store.commit('setMemberInfo', this.userInfo);
        this.$store.commit('savePages', pageRouteInfo);
        this.$emit('current-page', this.currentPageData);
      }
    },
    sendAttachLink(){
      //필요한 정보 memberSeq
      let userSeq = this.$store.getters.getUserSeq;
      let mobile = this.$store.getters.getMemberInfo.mobile;
      let gradeCode = this.$store.getters.getGradeCode;

      if(this.isEmpty(userSeq)){
        this.$swal.fire({title:'입력된 번호가 없습니다.'});
        return;
      }
      userSeq = String(this.$store.getters.getUserSeq);

      const result = this.$CryptoJS.AES.encrypt(
          //주민번호 뒷자리 암호화
          userSeq,
          this.key,
          {
            iv: this.iv,
            mode: this.$CryptoJS.mode.CBC,
            keySize: 256 / 32,
            padding: this.$CryptoJS.pad.Pkcs7,
          },
      ).toString();

      const param = {
        pass_code: result,     // 암호화 코드
        mobile: mobile,        // 핸드폰 번호
        option: "optAttach",   // 템플릿 옵션명
        grade_code: gradeCode, // 멤버 그룹 번호
        etc_info: "간편회원가입" // 메세지 분류
      };

      this.$http.post('/api/simplejoin/mms',param);
    },
    isEmpty(value) {
      return value === undefined || value === null || String(value).trim() === '';
    },
    showConfirm(){
      if(this.test_mode){
        //테스트용 성별 값
        this.isVerified = true;
        this.selectedGender = '1';
        this.nationalName = '내국인';
        this.userInfo.mobile = this.generatedPhoneNumber();
        this.$store.commit('setMemberInfo',this.userInfo);
        return;
      }
      //본인인증
      window.addEventListener("message", this.receiveMessage, false);
      window.open('https://auth.bgsoft.kr:8443/nice_module/chk', '_blank',  'width=500,height=600' );
    },
    async receiveMessage(response){
      const name = response.data.name;
      const mobile = response.data.phone;
      const birth = response.data.birth;
      const national = response.data.national;
      const gender = response.data.gender;

      if(this.isEmpty(name) || this.isEmpty(mobile)){
        await this.$swal.fire('오류가 발생했습니다.');
        this.isVerified = false;
        return;
      }

      this.userInfo.name = name;
      this.userInfo.mobile = mobile;
      this.userInfo.birth = birth;
      this.userInfo.national = national;
      this.userInfo.gender = this.changeGenderCode(national,gender,birth);

      this.selectedGender = gender;
      this.nationalName = this.getNationality(national);

      this.isVerified = true;
      this.$store.commit('setMemberInfo',this.userInfo);
    },
    changeGenderCode(national, gender, birth){
      if (national == "0") {  //내국인
        if (gender == "1") { //남성(1)
          if (birth[0] =="2"){  //2000년대생
            return "3";
          } else {
            return "1";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "4";
          } else {
            return "2";
          }
        }
      } else {  //외국인
        if (gender == "1") { //남성(1)
          if (birth[0] == "2"){  //2000년대생
            return "7";
          } else {
            return "5";
          }
        } else {              //여성(0)
          if (birth[0] == "2"){  //2000년대생
            return "8";
          } else {
            return "6";
          }
        }
      }
    },
    getNationality(national){
      return national == '0' ? '내국인' : '외국인';
    },
    generatedPhoneNumber(){
      let min = Math.pow(10, 10);
      let max = Math.pow(10, 11) - 1;
      // Math.random()을 사용하여 랜덤 숫자 생성 후 11자리로 만듭니다.
      let randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

      return randomNumber.toString(); // 문자열로 반환
    },
    removeHyphens(str) {
      return str.replace(/-/g, '');
    },
  },
}
</script>

<style scoped>

</style>